import { render, staticRenderFns } from "./UchartsAREA.vue?vue&type=template&id=60ea068d&scoped=true"
import script from "./UchartsAREA.vue?vue&type=script&lang=js"
export * from "./UchartsAREA.vue?vue&type=script&lang=js"
import style0 from "./UchartsAREA.vue?vue&type=style&index=0&id=60ea068d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea068d",
  null
  
)

export default component.exports